export default {
  namespaced: true,
  state: {
    trainIsTransfer: false, //火车票是否是中转
    transferListRefresh: false, //是否重新刷新中转列表
    trainDetailInfo: {}, //火车中转列表进入1.5详情数据
    mainTrainNo: '',
    mainTrainNoSeat: '',
    mainTrainSeats: [], // 主选车次的车次信息
    travelFormDates: [], // 抢票单，如果有多个备选日期，去到出差单列表的时候，需要传给出差单列表
  },
  mutations: {
    // 切换tab存储是否中转
    setTrainIsTransfer(state, data) {
      state.trainIsTransfer = data;
    },
    // 1.5无票返回中转列表要刷新
    setTransferListRefresh(state, data) {
      state.transferListRefresh = data;
    },
    // 存储火车票详情信息
    setTrainDetailInfo(state, data) {
      state.trainDetailInfo = data || {};
    },
    // 存储主选车次
    SETMAINTRAINNO(state, data) {
      state.mainTrainNo = data;
    },
    // 存储主选车次坐席
    SETMAINTRAINNOSEAT(state, data) {
      state.mainTrainNoSeat = data;
    },
    // 火车票从1.5进入填单页，存储主选车次的车次信息
    SETMAINTRAINSEATS(state, data) {
      state.mainTrainSeats = (data || []).map((item) => {
        return {
          SeatName: item.SeatName,
          Price: item.MaxPrice,
          SeatCode: item.SeatCode,
          extra: ['硬卧', '软卧', '高级软卧', '一等卧', '二等卧'].includes(item.SeatName) ? '下铺' : '',
          tips: item.SeatName === '无座' ? '成功率提高40%' : '',
        };
      });
    },
    SETTRAVELFORMDATES(state, data) {
      state.travelFormDates = data;
    },
  },
  actions: {},
};
